import {
  HostedIntegrationEditPage,
  HostedIntegrationEditPageProps,
} from "~/pages/integrations/hosted-integrations";

const HostedIntegrationEditEntryPage = ({
  scope,
}: HostedIntegrationEditPageProps) => {
  return <HostedIntegrationEditPage {...{ scope }} />;
};

export default HostedIntegrationEditEntryPage;
